// Exact segment match, so a store at /<handle> such as /vendorshop or
// /adminpk (store mode) keeps the normal storefront chrome.
const underSegment = (pathname, seg) => pathname === seg || pathname.startsWith(`${seg}/`);

/** True when storefront chrome (shop nav, search, wishlist, footer) should be hidden. */
export function isStorefrontChromeHidden(pathname) {
  if (!pathname) return false;
  return pathname === "/admin-login" || underSegment(pathname, "/admin") || underSegment(pathname, "/vendor");
}

/** True on authenticated admin workspace routes (not login). */
export function isAdminWorkspace(pathname) {
  if (!pathname) return false;
  return underSegment(pathname, "/admin");
}
